const SDK_VERSION = "11.9.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
